// Core components
import { Component, OnInit } from "@angular/core";

// Third party components
import { FieldType } from '@ngx-formly/core';
import { Subscription } from "rxjs";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { ConfigService } from 'src/app/shared/services/config.service';

// Custom components

@Component({
  selector: 'app-formly-attachments-type',
  template: `
    <div *ngIf="model && (model.files || model.invoiceFile)">
      <div *ngFor="let file of files">
        <a href="{{ file.url }}" target="_blank">{{ file.name }}</a><br>
      </div>
    </div>
    <div *ngIf="model && model.attachments">
      <div *ngFor="let attachment of attachments">
        <a href="{{ attachment.url }}" target="_blank">{{ attachment.name }}</a><br>
      </div>
    </div>
  `,
})

export class AttachmentsTypeComponent extends FieldType implements OnInit {
  files = [];
  attachments = [];
  private subscriptions: Subscription[] = [];

  /**
   * Class constructor
   */
  constructor(
    private configService: ConfigService,
    private propertiesService: PropertiesService,
  ) {
    super();
  }

  /**
   * Init component
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    // General purpose
    if (this.model.files) {
      this.model.files.forEach(file => {
        const path = file.path.replace(/src[\\\/]assets/g, 'public');
        let url = "";
        if (path.substring(0, 22) === "https://app.archedi.it") {
          url = path;
          // https://app.archedi.it/documents/c15bc5eb-bd5a-11e7-a685-000c29dd368f/005073000000S000001C.pdf
          // url = `https://api.archedi.it/uploads/properties/${propertyId}/documents/${filename}`;
        } else {
          url = `${this.configService.apiHost}/${path}`;
        }
        url = `${this.configService.apiHost}/${path}`;
        const newFile = {
          name: file.originalName,
          url,
        }
        this.files.push(newFile);
      });
    }

    // Communication's attachments
    if (this.model.attachments) {
      this.model.attachments.forEach(att => {
        const path = att.path.replace(/src[\\\/]assets/g, 'public');
        let url = "";
        if (path.substring(0, 22) === "https://app.archedi.it") {
          url = path;
        } else {
          url = `${this.configService.apiHost}/${path}`;
        }
        const newAttachment = {
          name: att.originalName,
          url,
        }
        this.attachments.push(newAttachment);
      });
    }

    // Balance's InvoiceFile (only 1)
    if (this.model.invoiceFile) {
      const files = this.model.invoiceFile;
      const propertyId = this.model.property ? this.model.property._id : undefined;
      if (!propertyId) {
        return;
      }
      if (Array.isArray(files)) {
        files.forEach((file: any) => {
          const path = file.path;
          let url = "";
          // if (path.substring(0, 22) === "https://app.archedi.it") {
          //   url = path;
          // } else {
          //   url = `${this.configService.apiHost}/${path}`;
          // }
          url = `${this.configService.apiHost}/${path}`;
          const newFile = {
            name: file.originalName,
            url: url,
          }
          this.files.push(newFile);
        })
      } else {
        const path = files.path; //.replace("temp", `properties/${propertyId}/balances`);
        let url = "";
        // if (path.substring(0, 22) === "https://app.archedi.it") {
        //   url = path;
        // } else {
        //   url = `${this.configService.apiHost}/${path}`;
        // }
        url = `${this.configService.apiHost}/${path}`;
        const newFile = {
          name: files.originalName,
          url: url,
        }
        this.files.push(newFile);
      }
    }
  }
}
